/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const ProfileTabsNavigation = dynamic(() => import('./ProfileTabsNavigation').then(mod => mod.ProfileTabsNavigation));

export const ProfileTabsNavigationConfig = {
  emptyLabel: 'profileTabsNavigation',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/profiletabsnavigation`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ProfileTabsNavigationEditable = (props: any) => (
  <EditableComponent config={ProfileTabsNavigationConfig} {...props}>
    <ProfileTabsNavigation {...props} />
  </EditableComponent>
);
